import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryNovaPoshtaForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-nova-poshta',
  templateUrl: './nova-poshta.component.html',
  styleUrls: ['./nova-poshta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NovaPoshtaComponent {
  delivery = input<DeliveryNovaPoshtaForm>();
}
